import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fill-height bg_auth",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_flex = _resolveComponent("v-flex")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_center = _resolveComponent("center")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_layout, {
      wrap: "",
      class: "login"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_center, {
          class: _normalizeClass(!_ctx.$vuetify.display.mobile ? 'login_card' : 'login_card_mobile')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_flex, {
              xs12: "",
              class: "text-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_img, {
                  src: "/img/bobbee_logo_3.png",
                  height: !_ctx.$vuetify.display.mobile ? '15vh' : '',
                  width: !_ctx.$vuetify.display.mobile ? '' : '25vw'
                }, null, 8, ["height", "width"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_flex, {
              xs12: "",
              class: "align-center"
            }, {
              default: _withCtx(() => [
                _cache[4] || (_cache[4] = _createElementVNode("h2", null, "Besoin d'un nouveau mot de passe ?", -1)),
                _cache[5] || (_cache[5] = _createElementVNode("p", null, [
                  _createTextVNode(" Entrez l'adresse email de votre compte bobbee."),
                  _createElementVNode("br"),
                  _createTextVNode(" Un email vous sera envoyé avec un lien de réinitialisation de votre mot de passe ")
                ], -1)),
                _createVNode(_component_v_form, {
                  ref: "form",
                  modelValue: _ctx.valid,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.valid) = $event)),
                  onSubmit: _withModifiers(_ctx.sendRecoveryLink, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      "mt-4": "",
                      class: "mt-4",
                      xs4: "",
                      modelValue: _ctx.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                      placeholder: "Email",
                      rules: [() => _ctx.pattern.test(_ctx.email) || 'Email invalide'],
                      required: ""
                    }, null, 8, ["modelValue", "rules"]),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          xs12: "",
                          class: "text-center mt-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: _ctx.sendRecoveryLink,
                              block: ""
                            }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("Envoyer")
                              ])),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          xs12: "",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: '/login',
                              style: {"cursor":"pointer","color":"black"}
                            }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode("Retour pour vous connecter")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onSubmit"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_flex, {
              xs12: "",
              "mt-5": "",
              "pt-5": "",
              class: "align-center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_alert, {
                  rounded: "",
                  type: "primary",
                  variant: "outlined",
                  "model-value": _ctx.isMailSent
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Un mail a été envoyé a l'adresse email indiquée."),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode(" Vous y trouverez les instructions pour modifier votre mot de passe. ")
                  ])),
                  _: 1
                }, 8, ["model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    })
  ]))
}